import { render } from "./TwoFactorSetupModal.vue?vue&type=template&id=608e9e2e&scoped=true"
import script from "./TwoFactorSetupModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorSetupModal.vue?vue&type=script&lang=js"

import "./TwoFactorSetupModal.vue?vue&type=style&index=0&id=608e9e2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608e9e2e"]])

export default __exports__